import {Injectable} from "@angular/core";
import {HttpClient} from "@angular/common/http";
import {properties} from "../../../environments/environment";
import {NotificationHandler} from "../utils/notification-handler";

@Injectable({
  providedIn: 'root'
})
export class UploadFileService {
  public types: Map<string, string> = new Map();

  constructor(private http: HttpClient) {
    this.types.set('csv', 'application/vnd.ms-excel');
    this.types.set('json', 'application/json');
  }

  upload(files: Array<File>, type: 'json' | 'csv' = 'csv') {
    let message: string;
    if (files.length == 0) {
      message = "There is no selected file to upload.";
    } else {
      if ([...files].filter(file => file.name.indexOf('.' + type) == -1 || file.type !== this.types.get(type)).length > 0) {
        message = "No valid file type. The required type is " + type.toUpperCase();
      }
    }
    if(message) {
      console.error(message);
      NotificationHandler.rise(message, 'danger');
      return null;
    } else {
      let url = properties.utilsService + '/upload?type=' + type;
      let formData = new FormData();
      for (let i = 0; i < files.length; i++) {
        formData.append("uploads[]", files[i], files[i].name);
      }
      return this.http.post<any>(url, formData, {withCredentials: true});
    }
  }
}
